import React from 'react';
import DataTable from 'react-data-table-component';
import queryString from 'query-string';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

import MessageStatus from '../Messages/List/Components/MessageStatus';

import Participant from '../Messages/List/Components/Participant';
import MessagesEmpty from '../Messages/List/Empty';
import StatusPopover from '../Messages/List/Components/StatusPopover';
import MostRecentMessage from '../Messages/List/Components/MostRecentMessage';

import withSocketService from './withSocketService';

import '../Messages/List/style.css'

function YourMessages({conversations, isLoading, history, totalConversations, location}) {
  const columns = [
    {
      name: <StatusPopover />,
      width: '45px',
      sort: false,
      cell: conversation => {
        return <div className='pl-3'>
          <MessageStatus conversation={conversation} />
        </div>
      }
    },
    {
      name: <div className='my-2'>
        <h6 className="mb-0 font-weight-bold">Initial Message</h6> <br />
        <span className='text-muted'>From</span>
      </div>,
      sort: false,
      cell: conversation => {
        return <div className='ml-3'>
          <Participant type='from' conversation={conversation} />
        </div>
      }
    },
    {
      name: <div className='text-muted mt-4'>To</div>,
      sort: false,
      cell: conversation => {
        return <div className='ml-2'>
          <Participant type='to' conversation={conversation} />
        </div>
      }
    },
    {
      name: <h6 className="font-weight-bold mt-4 mb-0">Most Recent Message</h6>,
      sort: false,
      width: '400px',
      cell: conversation => {
        return <MostRecentMessage lastMessage={conversation.lastMessage} />
      }
    },
    {
      button: true,
      sort: false,
      cell: conversation => {
        return <Link
          to={`/messages/${conversation.id}/view`}
          className="message__view__btn text-right my-3 my-sm-auto"> View</Link>
      }
    }
  ];

  return <div className="row">
    <div className="col-lg-12">
      { isLoading &&  <Spinner animation="border" role="status" /> }

      { !isLoading && totalConversations === 0 &&
        <MessagesEmpty />
      }

      { !isLoading && totalConversations > 0 &&
        <DataTable
          title="Your Messages"
          columns={columns}
          data={conversations}
          progressPending={isLoading}
          onChangePage={page => { history.replace(`/dashboard/messages?page=${page}`) }}
          striped={true}
          pagination={true}
          paginationServer={true}
          paginationTotalRows={totalConversations}
          paginationDefaultPage={parseInt(queryString.parse(location.search).page || 1)}
          paginationRowsPerPageOptions={[15]}
          paginationPerPage={15}
          noDataComponent={<div className="p-4">We could not find any results</div>}
          customStyles={{ cells: { style: { fontSize: '14px', padding: '1.5em 0 1.5em 0' }, }, }}
        />
      }
    </div>
  </div>
}

export default withSocketService(YourMessages);